import onlineCourse from 'iz-ds-neo-alt/dist/system/i18n/jp/onlineCourse'

const DETAIL = {
	MSG_NO_LESSON: '現在、このコースに講義がありません!',
}

export default {
  ...onlineCourse,
  DETAIL,
}